




export class SecondRequest {
    apTypeId: string;
    apTypeName: string;
    miApTypeName: string;
    secondRequest: string;
    is4DigitsCustomItem: boolean;


    constructor(apTypeId: string, apTypeName: string, miApTypeName: string, secondRequest: string, is4DigitsCustomItem: boolean = false) {
        this.apTypeId = apTypeId;
        this.apTypeName = apTypeName;
        this.miApTypeName = miApTypeName;
        this.secondRequest = secondRequest;
        this.is4DigitsCustomItem = is4DigitsCustomItem;
    }
}